import { render, staticRenderFns } from "./VendorDetails_Details.vue?vue&type=template&id=30bad883&"
import script from "./VendorDetails_Details.vue?vue&type=script&lang=js&"
export * from "./VendorDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports